import React, { Component, useState } from "react"
import * as helpers from "../../helpers/sectionclasses"
import loadable from "@loadable/component";

const VimeoPlyrEmbed = loadable(() => import("../vimeoplyrembed"), {
  ssr: false, // Disables Server-Side Rendering
});
// import VimeoPlyrEmbed from "../vimeoplyrembed"


const Hero = ({ content, sectionOptions }) => {
  const sectionClasses = helpers.sectionClasses(content.sectionOptions)
  const [isPlaying, setIsPlaying] = useState(false)
  function handlePlayChange() {
    setIsPlaying(true)
  }

  return (
    <section className={`relative hero w-screen ${sectionClasses}`}>
      <div
        className={`hero-marquee hero-marquee--masked text-white absolute left-0 top-1/2 transform -translate-y-1/2 z-20 transition transition-opacity${
          isPlaying ? " opacity-0" : ""
        }`}
      >
        <div className="marquee">
          <h1 className="clipped-text">
            {content.title}
            <span className="mr-20 inline-block"></span>
          </h1>
          <p className="clipped-text">
            {content.title}
            <span className="mr-20 inline-block"></span>
          </p>
        </div>
      </div>
      {content.video && content.vimeoUrl ? (
        <div className="container px-0 w-full lrg:px-7">
          <div className="relative w-full desk:px-6">
            <VimeoPlyrEmbed
              autoPlay={false}
              posterGif={true}
              posterGifSource={content.video}
              onChange={handlePlayChange}
              source={content.vimeoUrl}
              hero={true}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </section>
  )
}

export default Hero

// <CloudinaryVideo
//   class_list="w-full h-full object-cover"
//   publicUrl={content.video.mediaItemUrl}
// />
